var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
var defaultIcon = require('@/assets/images/company.png');
var CompanyAvatar = /** @class */ (function (_super) {
    __extends(CompanyAvatar, _super);
    function CompanyAvatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultIcon = defaultIcon;
        return _this;
    }
    Object.defineProperty(CompanyAvatar.prototype, "hasAvatar", {
        get: function () {
            return !!this.avatar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompanyAvatar.prototype, "initial", {
        get: function () {
            var name = (this.name || '').trim();
            return name ? Array.from(name)[0] : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompanyAvatar.prototype, "imageUrl", {
        get: function () {
            if (this.hasAvatar)
                return this.avatar;
            return this.initial ? '' : this.defaultIcon;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String })
    ], CompanyAvatar.prototype, "avatar", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], CompanyAvatar.prototype, "name", void 0);
    CompanyAvatar = __decorate([
        Component
    ], CompanyAvatar);
    return CompanyAvatar;
}(Vue));
export default CompanyAvatar;
